import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";
import { LicenseInfo } from "@mui/x-license-pro";

Amplify.configure(awsconfig);
//LicenseInfo.setLicenseKey(
//  "b5dd34fb5e1544164076b246810c56f2Tz05NDEwMyxFPTE3NTIzMTM0NTgwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI="
//);

// Version checking logic
const currentVersion = process.env.REACT_APP_VERSION;
const versionCheckDelay = process.env.REACT_APP_VERSION_DELAY_CHECK_MINS;

function checkAppVersionAndReload() {
  fetch("/index.html", { cache: "no-cache" })
    .then((response) => response.text())
    .then((htmlText) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, "text/html");
      const newVersion = doc
        .querySelector('meta[name="app-version"]')
        ?.getAttribute("content");

      if (newVersion && newVersion !== currentVersion) {
        console.log(`New version detected (${newVersion}), reloading...`);
        window.location.reload(true);
      }
    });
}

// Check once on load
checkAppVersionAndReload();
// Optionally: check every 1 minute
setInterval(checkAppVersionAndReload, versionCheckDelay * 60 * 1000); // 60,000ms = 1 min

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
